export const rootElementId = 'id-verification-vendor-iframe-container';
export const translation = {
  common: [],
  feature: 'Verification.Identity'
};
